import React from 'react';
import { Typography, useMediaQuery } from '@material-ui/core';

const TableTitle = ({ children }) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <Typography
      variant={isMobile ? 'h7' : 'h5'}
      style={{
        fontWeight: 'bold',
        padding: '10px 15px',
        color: '#3f51b5'
      }}
    >
      {children}
    </Typography>
  );
};

export default TableTitle;